import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBlob, ref } from "firebase/storage";
import { storage } from "../../api/firebaseApi";
import { GenerateDocumentsProps } from "../../helpers/helpers";
import { DataDocs } from "../../types/tables-data";

export type DocumentUrlResponse = {
  id: string;
  fileUrl: string;
};

export const generateDocumentUrls = createAsyncThunk(
  "document/generateDocumentUrls",
  async (
    { documents, mainDocId }: GenerateDocumentsProps,
    { rejectWithValue }
  ) => {
    try {
      const result: {
        id: string;
        fileUrl: string;
        mainDocId: string | undefined;
      }[] = [];
      const promises = documents.map(async (document) => {
        const fileRef = ref(storage, document.filePath);
        const fileBlob = await getBlob(fileRef);
        const fileUrl = URL.createObjectURL(fileBlob);
        result.push({
          id: document.id,
          fileUrl,
          mainDocId
        });
      });
      await Promise.allSettled(promises);
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

type SingleDocumentRequest = {
  id: string;
  filePath: string;
};

export const generateSingleDocumentUrl = createAsyncThunk<
  DocumentUrlResponse,
  SingleDocumentRequest,
  { rejectValue: Error }
>(
  "document/generateSingleDocumentUrl",
  async (document, { rejectWithValue }) => {
    try {
      const fileRef = ref(storage, document.filePath);
      const fileBlob = await getBlob(fileRef);
      const fileUrl = URL.createObjectURL(fileBlob);

      return { id: document.id, fileUrl };
    } catch (error) {
      return rejectWithValue(error as Error);
    }
  }
);

export const generateDocumentUrl = async (document: DataDocs) => {
  const fileRef = ref(storage, document.filePath);
  const fileBlob = await getBlob(fileRef);
  const fileUrl = URL.createObjectURL(fileBlob);
  return { id: document.id, fileUrl };
};
